import { OptionType } from 'types/OptionType'

/**
 * Resolves which locations a filter selection actually stands for.
 *
 * The location badges and the coverage notice both report on "the locations in view", and they
 * only agree if they agree on what that set is. They each derived it separately at first, and
 * the two grouping pseudo-options were where that went wrong: they carry no per-location meta,
 * so code that filters on `meta.integrationStatus` silently drops them and falls through to
 * every location. The badge then counted the group while the notice counted the whole org.
 *
 * One function, one answer:
 *   - "All PMS Integrated" stands for every location with a PMS connection, which includes the
 *     stale ones. It is a statement about setup, not about freshness.
 *   - "All Non-PMS Integrated" stands for the locations without one.
 *   - Real selections stand for themselves.
 *   - No selection stands for every location on the page.
 */
export function resolveLocationScope(locationOptions: OptionType[], selectedOptions?: OptionType[]): OptionType[] {
  const selected = selectedOptions ?? []
  if (selected.length === 1 && selected[0].value === `integrated`) {
    return locationOptions.filter((option) => option.meta?.integrationStatus !== `notIntegrated`)
  }
  if (selected.length === 1 && selected[0].value === `notIntegrated`) {
    return locationOptions.filter((option) => option.meta?.integrationStatus === `notIntegrated`)
  }
  const realSelections = selected.filter((option) => option.meta?.integrationStatus)
  return realSelections.length > 0 ? realSelections : locationOptions
}
